<template>
  <div>
    <sidebar></sidebar>
    <navbar :pageIndex="pageIndex"></navbar>
    <div class="service-container">
      <div class="photos">
        <img src="@/assets/image/serviceitem.jpg" alt="">
      </div>
      <div class="service-area">
        <div class="service-box" v-for="(item,key) in serviceItem" :key="key">
          <img :src="$img + item.coverImg" v-if="key%2==0">
          <div class="content">
            <p>{{item.title}}</p>
            <div class="l--l"></div>
            {{item.intro}}
          </div>
          <img :src="$img + item.coverImg" v-if="key%2==1">
        </div>
      </div>
    </div>
    <myFooter></myFooter>
  </div>
</template>

<script>
  import navbar from "../../components/navbar";
  import myFooter from "../../components/myFooter";
  import sidebar from "../../components/sidebar";

  export default {
    name: "index",
    components: {
      navbar,myFooter,sidebar
    },
    data() {
      return {
        pageIndex:3,
        serviceItem:{},
      }
    },
    created() {
      this.$http.get('/api/skills/info/list').then((res)=>{
        this.serviceItem = res.data.rows
        console.log(this.serviceItem)
      })
    }
  }
</script>

<style scoped>
  .photos {
    width: 100%;
    height: 0;
    padding-bottom: 18.7%;
  }
  .photos img{
    width: 100%;
  }

  .service-area {
    margin: 50px auto;
    width: 60%;
  }

  .service-box {
    padding: 50px;
    margin-bottom: 20px;
    transition: all .5s;
    display: flex;
    align-items: center;
  }
  .service-box img{
    width:40%;
  }

  .service-box:hover {
    box-shadow: 0 0 30px #ddd;
    transform: scale(1.05);
  }

  .service-box p {
    font-size: 32px;
    margin-bottom: 24px;
  }

  .content {
    width: 50%;
    padding: 0 20px 0 40px;
    line-height: 200%;
    /*text-indent: 2em;*/
    letter-spacing: 0.1em;
    font-size: 14px;
  }
  .content:nth-child(2n-1){
    padding: 0 40px 0 20px;
  }
  .l--l{
    width: 50px;
    border: 2px solid #3a4ccc;
    margin-bottom: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/service/index.vue